import React from 'react';
import { Upload, Mic, Headphones } from 'lucide-react';

const STEP_COLORS = [
  { bg: 'bg-royal-blue', light: 'bg-blue-50', text: 'text-royal-blue' },
  { bg: 'bg-yellow-400', light: 'bg-yellow-50', text: 'text-yellow-600' },
  { bg: 'bg-electric-green', light: 'bg-green-50', text: 'text-electric-green' },
];

const HowItWorksSection = () => {
  const steps = [
    {
      icon: Upload,
      title: 'Snap or Upload the Score',
      description: "Take a photo of the box score on your phone, upload a screenshot, or export a PDF from GameChanger. Either works — no special setup needed.",
    },
    {
      icon: Mic,
      title: 'We Build the Recap',
      description: "Sit back. We turn the stats into a fun, exciting podcast that shouts out your players by name and captures the highlights of the game.",
    },
    {
      icon: Headphones,
      title: 'Share It with Everyone',
      description: "You get a shareable link your whole family can open. Text it to Grandma. Post it to the team chat. They'll love it.",
    },
  ];

  return (
    <section id="how-it-works" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Section header */}
        <div className="text-center mb-14">
          <span className="inline-block text-xs font-bold text-royal-blue uppercase tracking-widest mb-3">How It Works</span>
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 tracking-tight">
            Three Steps to <span className="text-yellow-500">Something Special</span>
          </h2>
          <p className="text-gray-500 mt-3 max-w-xl mx-auto text-base">
            Upload after the game, and your recap will be ready and waiting — no effort on your end.
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-3 gap-6">

          {steps.map((step, index) => {
            const color = STEP_COLORS[index];
            const Icon = step.icon;
            return (
              <div key={index} className="group bg-white rounded-2xl border border-gray-100 shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300 p-7 flex flex-col items-start">
                {/* Number + icon */}
                <div className="flex items-center gap-3 mb-5">
                  <div className={`w-12 h-12 rounded-2xl ${color.bg} flex items-center justify-center shadow-md shrink-0`}>
                    <Icon className="h-6 w-6 text-white" />
                  </div>
                  <span className={`text-4xl font-black ${color.text} leading-none`}>0{index + 1}</span>
                </div>
                <h3 className="text-lg font-black text-gray-900 mb-2">{step.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{step.description}</p>
                {/* Bottom accent */}
                <div className={`mt-5 h-1 w-12 rounded-full ${color.bg} group-hover:w-full transition-all duration-500`} />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
